import { type RouteObject } from 'react-router-dom';

export const seasonPassRoute: RouteObject = {
  path: 'season-passes',
  children: [
    {
      path: '',
      lazy: () => import('./seasonPasses'),
    },
  ],
};
